var _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalButtons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_8808_44216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2855 13.842C14.9358 14.4015 14.1664 14.5764 13.6069 14.2267L9.34058 11.499C8.5013 10.9745 8.01172 10.1002 8.01172 9.12107C8.01172 8.14191 8.46633 7.26766 9.27064 6.70814C10.6694 5.76395 12.4879 5.76395 13.8867 6.70814L14.9358 7.40754C15.4953 7.79221 15.6352 8.52658 15.2855 9.12107C14.9008 9.68058 14.1664 9.82046 13.5719 9.47076L12.5228 8.77137C11.9633 8.3867 11.194 8.3867 10.6345 8.77137C10.4946 8.87628 10.4596 9.01616 10.4596 9.12107C10.4596 9.191 10.4946 9.36585 10.6345 9.43579L14.9008 12.1634C15.4953 12.5131 15.6352 13.2825 15.2855 13.842Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.2189 17.1969L8.54035 16.0779C7.98083 15.6932 7.84095 14.9589 8.19065 14.3644C8.57532 13.8049 9.30969 13.63 9.90418 14.0147L11.5827 15.1337C12.1423 15.5184 12.2821 16.2528 11.9324 16.8472C11.5478 17.4068 10.7784 17.5816 10.2189 17.1969Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_8808_44216",
    x: 8.01172,
    y: 6,
    width: 8.14599,
    height: 9.0874,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.681146,
    dy: 0.681146
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.567621
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.152941 0 0 0 0 0.313726 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8808_44216"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalButtons);
export default __webpack_public_path__ + "static/media/totalButtons.3ba08a258745051abd6dc43478a49e02.svg";
export { ForwardRef as ReactComponent };